import PatchOps from '@leverege/api-patch-ops'
import { updateAlert } from './BlueprintActions'

/*
  Usage:
    let updater = AlertUpdater( store, blueprint, alert )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function AlertUpdater( store, blueprint, alert, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    store.dispatch( updateAlert( blueprint, alert, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = AlertUpdater;
